<script setup>
/**
 * FormHeader
 * The primary toolbar for form views. Provides navigation context,
 * action buttons for record creation, and save triggers.
 */
import { computed, getCurrentInstance } from 'vue';
import FormAddBtn from './FormAddBtn';
import FormDisplayTitle from './FormDisplayTitle';
import ShowSiteTreeBtn from '../../common/ShowSiteTreeBtn';
import FormSaveBtn from './FormSaveBtn';
import FormSaveCloseBtn from './FormSaveCloseBtn';

const props = defineProps({
    formId: {
        type: String,
        required: true
    },
    showAddBtn: Boolean,
    showSaveBtn: Boolean,
    showSaveAndCloseBtn: Boolean
});

const { proxy } = getCurrentInstance();
const store = proxy.$store;

// --- Computed ---

const formState = computed(() => store.state[props.formId]);

const tableName = computed(() => formState.value?.tableName);

const id = computed(() => formState.value?.id);

const show = computed(() => props.showAddBtn);

// --- Methods ---

const formScrollTop = (e) => {
    // Logic remains placeholder as per original todo
};
</script>

<template>
    <header class="d-flex border-bottom" @click="formScrollTop">
        <div class="flex-fill d-flex align-items-center">
            <ShowSiteTreeBtn
                :table-name="tableName"
                :id="id"
                :site-tree-id="'siteTreeOffcanvas'"
            />

            <FormAddBtn v-if="show" :form-id="formId"/>

            <FormDisplayTitle :form-id="formId"/>
        </div>

        <FormSaveBtn
            v-if="showSaveBtn"
            :form-id="formId"
            class="rounded-0"
        />

        <FormSaveCloseBtn
            v-if="showSaveAndCloseBtn"
            :form-id="formId"
        />
    </header>
</template>